import {CSSProperties, FC} from 'react';


export interface IIconHeart2Props {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconHeart2: FC<IIconHeart2Props> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 15"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M12.645.581c.862 0 1.704.253 2.42.725a4.31 4.31 0 0 1 1.604 1.928c.33.785.415 1.648.247 2.481a4.276 4.276 0 0 1-1.192 2.199l-.518.515-.687.673L9.042 14.5 3.566 9.103l-.688-.673-.518-.516a4.297 4.297 0 0 1-.994-1.394 4.244 4.244 0 0 1 .91-4.76 4.364 4.364 0 0 1 1.44-.943A4.414 4.414 0 0 1 7.104.86c.534.23 1.015.562 1.415.979l.523.515.524-.515A4.388 4.388 0 0 1 12.644.582" />
        </svg>
    );
};
